import { useAppDispatch } from "Store/hooks";

import { deleteVariable } from "../thunks";

import type { Variable } from "@packages/client";

export function useDeleteVariable({
  organizationId,
  projectId,
  variable,
  environmentId
}: {
  organizationId: string;
  projectId: string;
  variable: Variable;
  environmentId: string;
}) {
  const dispatch = useAppDispatch();

  return async () =>
    await dispatch(
      deleteVariable({
        organizationId,
        projectId,
        variable,
        environmentId
      })
    );
}
